export { AuthorPage, type AuthorPageProps } from "./AuthorPage";
